import { isEqual } from 'lodash';

import bus from '@/utils/bus';

const COUNT = {
  NO_LIMIT: 0,
  ONE: 1,
};

export default {
  name: 'MenuItemOption',
  props: {
    entree: {
      required: true,
      type: Object,
    },
    entreeIdentifier: {
      required: true,
      type: Number,
    },
    option: {
      required: true,
      type: Object,
    },
    value: [Number, String, Array, Object, null],
  },
  data() {
    return {
      curSelected: this.chosen?.onlyOne ? null : [],
      isDirty: false,
      isValid: false,
    };
  },
  computed: {
    chosen() {
      return {
        atLeast: this.min >= COUNT.ONE && this.max === COUNT.NO_LIMIT,
        between: this.min >= COUNT.ONE && this.max > COUNT.ONE,
        maximum: this.min === COUNT.NO_LIMIT && this.max > COUNT.NO_LIMIT,
        noLimit: this.min === COUNT.NO_LIMIT && this.max === COUNT.NO_LIMIT,
        onlyOne: this.min === COUNT.ONE && this.max === COUNT.ONE,
        specific: this.min > COUNT.ONE && this.min === this.max,
      };
    },
    hasPassValidation() {
      return this.isRequired ? this.isValid && this.isDirty : true;
    },
    isRadio() {
      return !!this.chosen?.onlyOne;
    },
    isRequired() {
      return this.min >= COUNT.ONE;
    },
    items() {
      const { items = [] } = this.option || {};
      return items.map((item) => ({
        ...item?.toJson(),
        disabled: this.isItemDisabled(item),
      })) || [];
    },
    max() {
      const { max } = this.optionRules;
      return max;
    },
    min() {
      const { min } = this.optionRules;
      return min;
    },
    name() {
      return this.option?.name || '';
    },
    optionRules() {
      const { rules = {} } = this.option || {};
      return rules;
    },
    selectionRemind() {
      if (this.chosen?.atLeast) {
        return `至少選擇 ${this.min} 項`;
      }
      if (this.chosen?.maximum) {
        return `最多可選擇 ${this.max} 項`;
      }
      if (this.chosen?.between) {
        return `請選擇 ${this.min}-${this.max} 項`;
      }
      if (this.chosen?.specific) {
        return `請選擇 ${this.min} 項`;
      }
      return '';
    },
  },
  created() {
    bus.$on('VALIDATE_OPTIONS', () => {
      this.isDirty = true;
    });
  },
  mounted() {
    this.emitIsValidStatus();
  },
  watch: {
    curSelected: {
      deep: true,
      handler(newVal, oldVal) {
        const selectedCheckboxes = this.getSelectedArray(newVal);
        if (this.isRadio) {
          this.select(newVal);
          this.deselect(oldVal);
        } else {
          const keys = Object.keys(newVal);
          for (let index = 0; index < keys?.length; index += 1) {
            const element = +keys[index];
            const selected = newVal[element];
            if (selected) {
              this.select(element);
            } else {
              this.deselect(element);
            }
          }
        }

        const validChk = this.isValidChk(selectedCheckboxes);
        const validRadio = this.isValidRadio(newVal);

        this.isValid = validChk || validRadio;
        if (!isEqual(newVal, oldVal) && !this.isDirty) {
          this.isDirty = true;
        }
      },
    },
    isDirty(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.emitIsValidStatus();
      }
    },
    isValid(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.emitIsValidStatus();
      }
    },
  },
  methods: {
    deselect(val) {
      const optionIndex = this.option?.index;
      this.entree.deselect(optionIndex, val, this.entreeIdentifier);
      bus.$emit('CALCULATE_ENTREE_TOTAL');
    },
    emitIsValidStatus() {
      this.$emit('is-valid', this.hasPassValidation);
    },
    getSelectedArray(selectedObject = {}) {
      const selectedArr = Object.keys(selectedObject) || [];
      return selectedArr?.filter((key) => selectedObject[key]) || [];
    },
    isItemDisabled(item = {}) {
      const curSelected = this.getSelectedArray(this.curSelected);
      return (
        !this.chosen?.noLimit
        && !this.chosen?.atLeast
        && curSelected?.length >= this.max
        && !curSelected?.some(((itemIndex) => +itemIndex === item?.index))
      ) || false;
    },
    isValidChk(items = []) {
      if (this.chosen?.atLeast) {
        return items?.length >= this.min;
      }

      return items?.length >= this.min && items?.length <= this.max;
    },
    isValidRadio(val) {
      return Number.isInteger(val);
    },
    select(val) {
      const optionIndex = this.option?.index;
      this.entree.select(optionIndex, val, this.entreeIdentifier);
      bus.$emit('CALCULATE_ENTREE_TOTAL');
    },
  },
};
